import { BlockType } from '../../types/index.js';
import { MembersAvatarsBlock as Component } from './Block.js';
export const RegisteredMembersAvatarsBlock = (_intl) => ({
    recommendedName: 'MembersAvatars',
    Component,
    config: {
        type: BlockType.Block,
        usable: false,
        displayName: 'Members avatars',
    },
});
//# sourceMappingURL=registered.js.map